import { Grid, makeStyles } from '@material-ui/core'
import useTranslate from '../../../i18n/useTranslate'
import { Draggable, DraggingStyle, NotDraggingStyle } from 'react-beautiful-dnd'
import Order from './Order'

import { ConsiderationDataListType } from '../../../services/um/useSearchSettingConsideration'

const getItemStyle = (
    isDragging: boolean,
    draggableStyle: DraggingStyle | NotDraggingStyle | undefined,
): React.CSSProperties => ({
    userSelect: 'none',
    padding: '24px',
    margin: '0 0 16px 0',

    // dragging
    backgroundColor: '#fff',
    border: isDragging ? '1px solid #db5f8e' : '1px solid #bdbdbd',
    borderRadius: '4px',

    ...draggableStyle,
})

type FiledDraggableProps = {
    dataList: ConsiderationDataListType[]
    isDragDisabled: boolean
}

const FiledDraggable = ({ dataList, isDragDisabled }: FiledDraggableProps) => {
    const translate = useTranslate()
    const classes = useStyles()

    return (
        <Grid container>
            {dataList.length > 0 &&
                dataList.map((item: ConsiderationDataListType, index: number) => {
                    return (
                        <Grid item xs={12} key={item.approveStatusID}>
                            <Draggable
                                key={item.approveStatusID}
                                draggableId={`${item.approveStatusID}`}
                                index={index}
                                isDragDisabled={isDragDisabled}
                            >
                                {(provided, snapshot): JSX.Element => (
                                    <div
                                        className={classes.root}
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                                    >
                                        <Order
                                            index={index}
                                            approveStatusID={item.approveStatusID}
                                            nameTH={item.name['th']}
                                            nameEN={item.name['en']}
                                            order={item.order}
                                        />
                                    </div>
                                )}
                            </Draggable>
                        </Grid>
                    )
                })}
        </Grid>
    )
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100% !important',
        '&:hover': { border: '1px solid #db5f8e !important' },
    },
}))

export default FiledDraggable
